<template>
    <component :is="template" v-if="template" ref="renderer" v-bind="templateProps" @goto-page="onGotoPage"
        @update-user="onUpdateUser">
        <template v-slot:overlays>
            <v-overlay :value="loading">
                <v-progress-circular indeterminate size="64" />
            </v-overlay>
            <v-snackbar v-for="(snack, index) in snacks" :key="index" v-model="snack.visible" :color="snack.color">
                <div class="d-flex flex-row justify-space-between">
                    <v-list color="transparent" dense one-line>
                        <v-list-item>
                            <v-list-item-title>
                                {{ snack.message }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-for="(si, sindex) in snack.items" :key="`snack-${index}-${sindex}`">
                            <v-list-item-title>{{ si }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                    <v-btn color="white" icon @click="snack.visible = false">
                        <v-icon small>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </div>
            </v-snackbar>
        </template>
    </component>
    <v-alert v-else>
        No template is defined in Page Body
    </v-alert>
</template>

<script>
import CenteredTemplate from "./templates/Centered.vue";
import AppBarTemplate from "./templates/AppBar.vue";
import AdminTemplate from "./templates/AdminBar.vue";

import FormJSONRenderer from "./Lib/vuetify-formjson/Fields/FormJSONBuilder/generator";

export default {
    name: "App",
    components: {
        Centered: CenteredTemplate,
        AppBar: AppBarTemplate,
        AdminBar: AdminTemplate
    },
    mixins: [FormJSONRenderer],
    data() {
        return {
            template: null,
            templateProps: null,
            loading: false,
        };
    },
    computed: {},
    mounted() {
        this.$store.state.host = this;

        if (window.PageConfig) {
            this.$nextTick(() => {
                this.updatePageWithData(window.PageConfig);
            })
        }
    },
    methods: {
        onGotoPage(page, data) {
            this.loading = true;
            this.axios({
                url: page,
                method: "GET",
                headers: this.getWebAuthHeaders({ Accept: "application/json" })
            })
                .then(response => {
                    this.loading = false;
                    this.updatePageWithData(response.data);
                    window.history.pushState(
                        `${response.data.title
                            .toLowerCase()
                            .replace(/g /, "")}-${Date.now().toFixed()}`,
                        response.data.title,
                        page
                    );
                })
                .catch(error => {
                    if (error.response && error.response.message) {
                        this.snacks.push({
                            visible: true,
                            message: error.response.message
                        });
                    }
                });
        },

        onUpdateUser(user, token) {
            this.$store.state.user = user;
            this.$store.state.tokens = { api: token };
        },

        updatePageWithData(data) {
            window.document.title = data.title;
            this.$nextTick(() => {
                this.templateProps = {
                    body: data.body,
                    options: data.body?.template?.props,
                    sources: data.sources,
                    id: 'page'
                };
                this.loading = false;
                this.template = data.body?.template?.name;

                if (this.$store.state.user === null || data.user != null) {
                    this.onUpdateUser(data.user, data.tokens.api);
                }
                if (data.currencies) {
                    this.$store.state.currencies = data.currencies;
                }
                if (data.channels) {
                    this.$store.state.channels = data.channels;
                }
            })
        },
    }
};
</script>
